import React from 'react';
import { Box, Typography } from '@mui/material';
import img from '../../images/garder.jpg'; // Replace with your actual image path
import { keyframes } from '@mui/system';

// Define the fade-in animation


function AboutOne() {
  return (
    <Box
      sx={{
        position: 'relative',
        height: '60vh',
        backgroundImage: `url(${img})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white',
        textAlign: 'center',
        overflow: 'hidden',
      }}
    >
      {/* Overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.6)', // Dark overlay for better text visibility
          zIndex: 1,
        }}
      />

      {/* Content */}
      <Box
        sx={{
          zIndex: 2, // Ensure content is above the overlay
          maxWidth: '800px', // Optional: Limit the width for better text alignment
          px: 2, // Padding for small screens
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            fontSize: '1rem',
            letterSpacing: '0.1rem',
            marginBottom: '1rem',
            textTransform: 'uppercase',
          }}
        >
          An Icon Since 2023
        </Typography>
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: '2.5rem', md: '3rem' },
            fontWeight: 'bold',
            marginBottom: '1rem',
            fontFamily: 'Georgia, serif',
          }}
        >
          About Us
        </Typography>
        <Typography
          variant="subtitle2"
          sx={{
            fontSize: { xs: '1rem', md: '1.2rem' },
            fontWeight: 300,
          }}
        >
          Unseen Knuckles Eco Boutique
        </Typography>
      </Box>
    </Box>
  );
}

export default AboutOne;
